import { createSubscribableMutator } from '@famly/vet_apollo-utils_create-subscribable-mutator';
import { DeleteLeaveSubtype } from './delete-leave-subtype.mutation';
export const { useSubscribableMutation: useDeleteLeaveSubtype, useSubscribeMutationResult: useSubscribeDeleteLeaveSubtypeResult, useUpdateCache: useUpdateDeleteLeaveSubtypeCache, } = createSubscribableMutator(DeleteLeaveSubtype);
